module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-view"
  }, [_c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "containerMap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "filters col-md-3"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('label.filter')))]), _vm._v(" "), _vm._l((_vm.chartData.fields), function(field, index) {
    return _c('div', {
      key: index,
      staticClass: "filter"
    }, [_c('label', {
      attrs: {
        "for": index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedField),
        expression: "selectedField"
      }],
      attrs: {
        "type": "radio",
        "id": index
      },
      domProps: {
        "value": field,
        "checked": _vm._q(_vm.selectedField, field)
      },
      on: {
        "__c": function($event) {
          _vm.selectedField = field
        }
      }
    }), _vm._v(" " + _vm._s(field) + "\n      ")])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-611b1dee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/MapsView.vue
// module id = 510
// module chunks = 1